module.exports = __webpack_public_path__ + "494cd07c/img/scraper-icon.df6ccde5.svg";